// import { AppContext } from "./AppContext";
import { AppContext } from "./AppContext";
import React, { useState } from "react";
const AppState = (props) => {
  const [sidebar, setSidebar] = useState(true);
  const [count, setCount] = useState({
    adminCount: 0,
    userCount: 0,
    vendingMachineCount: 0,
    categoriesCount: 0,
    productsCounts: 0,
    ordersCount: 0,
    transactionCount: 0,
    qrCodeCount: 0,
    queryCount: 0,
  });
  const [customerData, setCustomerData] = useState({
    customer_id: localStorage.getItem("id") ? localStorage.getItem("id") : null,
    role: localStorage.getItem("role") ? localStorage.getItem("role") : null,
    auth_token: localStorage.getItem("auth_token")
      ? localStorage.getItem("auth_token")
      : null,
    dob: localStorage.getItem("dob") ? localStorage.getItem("dob") : null,
    email: localStorage.getItem("email") ? localStorage.getItem("email") : null,
    full_name: localStorage.getItem("full_name")
      ? localStorage.getItem("full_name")
      : null,
  });

  const [rowLimit, setRowLimit] = useState(15);
  const [LinkproductId, setLinkproductId] = useState("")
  const [LinkVendingmachineid, setLinkVendingmachineid] = useState("")
  const [Linkslotno, setLinkslotno] = useState("")
  const [Linkdevicetoken, setLinkdevicetoken] = useState("")
  const [LinkOrderId, setLinkOrderId] = useState("")
  const [ageTokan, setAgeTokan] = useState("");
  console.log(LinkproductId)
  const [PickupId, setpickID] = useState("");
  console.log("PickupId", PickupId);
  return (
    <div>
      <AppContext.Provider
        value={{
          sidebar,
          setSidebar,
          customerData,
          setCustomerData,
          rowLimit,
          setRowLimit,
          LinkproductId, setLinkproductId,
          LinkVendingmachineid, setLinkVendingmachineid,
          Linkslotno, setLinkslotno,
          Linkdevicetoken, setLinkdevicetoken,
          LinkOrderId, setLinkOrderId,
          ageTokan, setAgeTokan,
          PickupId, setpickID
        }}
      >
        {props.children}
      </AppContext.Provider>
    </div>
  );
};

export default AppState;
